import { render, staticRenderFns } from "./set-permision.vue?vue&type=template&id=40434390&scoped=true&"
import script from "./set-permision.vue?vue&type=script&lang=ts&"
export * from "./set-permision.vue?vue&type=script&lang=ts&"
import style0 from "./set-permision.vue?vue&type=style&index=0&id=40434390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40434390",
  null
  
)

export default component.exports